import * as React from 'react';
import { clsx as cn } from 'clsx';
import * as styles from '../../styles.css';

import { UIHeading4, ArticleParagraph1, UIText1, UIText2, IconChevronRight16, ArticleParagraph2 } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';

interface IServicesProps {
  title: string;
  description?: string;
  img?: string;
  icon?: React.ReactNode;
  iconLink?: string;

  onClick(): void;

  isDesktop: boolean;
  isSmallDescription?: boolean;
  filled?: boolean;
  regularTitle?: boolean;
}

export const OtherServices: React.FC<IServicesProps> = ({
  title,
  description,
  img,
  icon,
  iconLink,
  onClick,
  isDesktop,
  isSmallDescription,
  filled,
  regularTitle,
}) => {
  const Title = regularTitle ? UIText1 : UIText2;

  return (
    <div
      className={cn(styles['service'], {
        [styles['service-large']]: isDesktop,
        [styles['service-small']]: !isDesktop,
        [styles['service-fill']]: filled,
      })}
      onClick={onClick}
    >
      <div className={styles['content']}>
        {img && <div className={cn(styles['img'], styles[img])} />}
        {icon && <div className={styles['icon']}>{icon}</div>}
        {iconLink && <img className={styles['img']} src={iconLink} />}
        <div>
          <div className={styles['content-title']}>
            <ConditionalWrapper if={isDesktop && !regularTitle} ThenComponent={UIHeading4} ElseComponent={Title}>
              {title}
            </ConditionalWrapper>
          </div>

          {description && (
            <ConditionalWrapper
              if={!!isSmallDescription}
              ThenComponent={ArticleParagraph2}
              ElseComponent={ArticleParagraph1}
              color="gray60_100"
            >
              {description}
            </ConditionalWrapper>
          )}
        </div>
      </div>
      {isDesktop && <IconChevronRight16 />}
    </div>
  );
};

OtherServices.displayName = 'OtherServices';
